module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "other"
  }), _vm._v(" "), _c('p', {
    staticClass: "other"
  }), _vm._v(" "), _c('p', {
    staticClass: "other"
  }), _vm._v(" "), _c('p', {
    staticClass: "other"
  }, [_vm._v("Other Cathy"), _c('sup', [_vm._v("®")]), _vm._v(" Books from Andrews McMeel Publishing")]), _vm._v(" "), _c('p', {
    staticClass: "other1"
  }, [_vm._v("I Am Woman, Hear Me Snore"), _c('br'), _vm._v("\nAbs of Steel, Buns of Cinnamon"), _c('br'), _vm._v("Understanding the “Why” Chromosome"), _c('br'), _vm._v("The Child Within Has Been Awakened But the Old Lady on the Outside Just Collapsed"), _c('br'), _vm._v("Revelations from a 45-Pound Purse"), _c('br'), _vm._v("Only Love Can Break a Heart, But a Shoe Sale Can Come Close"), _c('br'), _vm._v("$14 in the Bank and a $200 Face in My Purse"), _c('br'), _vm._v("My Granddaughter Has Fleas!!"), _c('br'), _vm._v("Why Do the Right Words Always Come Out of the Wrong Mouth?"), _c('br'), _vm._v("A Hand to Hold, an Opinion to Reject"), _c('br'), _vm._v("Thin Thighs in Thirty Years"), _c('br'), _vm._v("Wake Me Up When I’m a Size 5"), _c('br'), _vm._v("Men Should Come with Instruction Booklets"), _c('br'), _vm._v("A Mouthful of Breath Mints and No One to Kiss"), _c('br'), _vm._v("Another Saturday Night of Wild and Reckless Abandon")]), _vm._v(" "), _c('p', {
    staticClass: "other1"
  }, [_vm._v("Cathy Twentieth Anniversary Collection"), _c('br'), _vm._v(" Reflections: A Fifteenth Anniversary Collection")]), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img_0352.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "other1"
  }, [_vm._v("Confessions to My Mother"), _c('br'), _vm._v(" Girl Food: Cathy’s Cookbook for the Well-Balanced Woman")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-649c0459","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ISE_03.vue
// module id = 60
// module chunks = 0